<template>
  <div class="login-container">
    <div class="backHeader">
        <div class="headerLeft" style="cursor: pointer;color: #EF4A4A;font-weight: bold;" @click="$router.push({path:'/index'})">
            回到首页
        </div>
        <div class="headerMain">登录页</div>
        <div class="headerRight"></div>
    </div>
    <a-row>
      <a-col :xs="{ span: 12, offset: 2 }" :sm="12" :md="8" :lg="8" :xl="4">
        <img @click="$router.push({path:'/index'})" src="../assets/image/login-logo.png" style="width: 100%;margin-top: 22px;cursor: pointer;" alt="">
      </a-col>
    </a-row>
    <a-row>
      <a-col :offset="2">
        <p class="textP">欢迎登陆</p>
      </a-col>
    </a-row>
    <div class="login-content">
      <a-row type="flex" justify="center">
        <a-col :xs="{ span: 20 }" :sm="12" :md="8" :lg="8" :xl="8">
          <a-form-model layout="vertical" :model="formLogin" ref="ruleForm">
            <a-form-model-item label="学习账号" prop="account"
              :rules="[{ required: true, message: '请输入账号', trigger: 'blur' }]">
              <a-input v-model="formLogin.account" placeholder="请输入手机号码" />
            </a-form-model-item>
            <a-form-model-item label="密码" prop="password"
              :rules="[{ required: true, message: '请输入密码', trigger: 'blur' }]">
              <a-input-password v-model="formLogin.password" placeholder="请输入8-16位字母加数字" />
            </a-form-model-item>
            <a-form-model-item label="验证码" prop="password"
              :rules="[{ required: true, message: '请输入验证码', trigger: 'blur' }]">

              <a-row>
                <a-col :span="12">
                  <a-input v-model="formLogin.inputCodeContent" placeholder="请输入验证码" />
                </a-col>
                <a-col :span="12">
                  <img v-if="requestCodeSuccess" style="margin-top: 2px;cursor: pointer;" :src="randCodeImage"
                    @click="handleChangeCheckCode" />
                  <img v-else style="margin-top: 2px" src="@/assets/checkcode.png" @click="handleChangeCheckCode" />
                </a-col>
              </a-row>
            </a-form-model-item>
            <a-form-model-item prop="password" :rules="[{ required: true, message: '请输入勾选隐私协议', trigger: 'blur' }]">
              <a-checkbox @change="onChange">点击阅读并同意《隐私协议》</a-checkbox>
            </a-form-model-item>
            <a-form-model-item>
              <div class="buttonBox" @click="onSubmit">登 陆</div>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </div>

  </div>
</template>
<script>
import { mapActions } from "vuex";
import { getAction } from '@/api/manage'
export default {
  name: 'login-container',
  components: {},
  data() {
    return {
      formLogin: {},
      currdatetime: null,
      requestCodeSuccess: false
    }
  },
  created() {
    this.handleChangeCheckCode()
  },
  mounted() { },
  methods: {
    ...mapActions(["Login", "Logout", "PhoneLogin"]),
    handleChangeCheckCode() {
      this.currdatetime = new Date().getTime();
      getAction(`/sys/randomImage/number/${this.currdatetime}`)
        .then((res) => {
          if (res.success) {
            this.randCodeImage = res.result;
            this.requestCodeSuccess = true;
            this.$forceUpdate()
          } else {
            this.$message.error(res.message);
            this.requestCodeSuccess = false;
          }
        })
        .catch(() => {
          this.requestCodeSuccess = false;
        });
    },
    onChange() { },
    onSubmit() {
      let loginParams = {}
      let that = this
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          loginParams.username = that.formLogin.account;
          loginParams.password = that.formLogin.password;
          loginParams.remember_me = false;
          loginParams.captcha = that.formLogin.inputCodeContent;
          loginParams.checkKey = that.currdatetime;
          that.Login(loginParams)
            .then((res) => {
              document.title = res.result.schoolName
              that.$router.push({ path: "/index" });
              that.$message.success('登陆成功!')
            })
            .catch((err) => {
              this.$message.error(err.message)
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  }
}
</script>
<style lang='scss' scoped>
.backHeader{
    width: 100%;
    height: 49px;
    background: #F4F4F4;
    padding: 0 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ccc;
    .headerMain{
        font-size: 16px;
        color: #303030;
        line-height: 50px;
    }
}
.login-container {
  background: linear-gradient(#F15051 24%, #fff 80%, #fff 100%);
  width: 100%;
  min-height: 100vh;

  .textP {
    font-size: 43px;
    font-family: SSZhengYaTi;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 55px;
    padding: 35px 0;
  }

  .login-content {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    background: #fff;
    border-radius: 28px 28px 0 0;
    padding-top: 82px;

    .buttonBox {
      width: 241px;
      height: 42px;
      background: #EF4A4A;
      border-radius: 19px;
      margin: 0 auto;
      font-size: 19px;
      text-align: center;
      line-height: 42px;
      color: #fff;
    }
  }

}
</style>
